import { IRegistryInvoice } from "dto/Invoices/IRegistryInvoice";
import { IStatus } from "dto/IStatus";
import InvoicePdfSlide from "components/CreateInvoiceRegistryModal/InvoicePdfSlide";
import InvoiceMetricBody from "./InvoiceMetricBody";
import styles from "./styles.module.scss";

interface Props {
  invoice: IRegistryInvoice;
  /** Status workflow z kolumny listy — pokazywany w metryce jako badge „Status". */
  workflowStatus?: IStatus;
  /** Ukryty wyzwalacz „Cofnij księgowanie" (undo zaksięgowanego) — renderowany, gdy podany. */
  onUndoPosting?: () => void;
  onClose: () => void;
}

// Metryka dokumentu w LAYOUCIE MODELU 1 (SplitSlide): podgląd pliku po lewej
// (auto-ładowany przez InvoicePdfSlide — KSeF/FileUri), metryka po prawej. Ten sam
// mechanizm co dekretacja faktur i Rozrachunki (SettlementsRegister) — zamiast
// dawnego własnego overlaya z warunkowo dostawianym panelem PDF (model 2).
const InvoiceMetricSlide = ({
  invoice,
  workflowStatus,
  onUndoPosting,
  onClose,
}: Props) => {
  const title = invoice.InvoiceNumber
    ? `Metryka dokumentu — ${invoice.InvoiceNumber}`
    : "Metryka dokumentu";

  return (
    <InvoicePdfSlide invoice={invoice} title={title} onClose={onClose}>
      {onUndoPosting && (
        <div className={styles.childToolbar}>
          <button
            type="button"
            onClick={onUndoPosting}
            title="Cofnij księgowanie — dokument wróci do „Do zadekretowania”"
            style={{
              border: "1px solid #d5b4b4",
              background: "transparent",
              color: "#b3261e",
              borderRadius: 6,
              padding: "4px 10px",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Cofnij księgowanie
          </button>
        </div>
      )}
      <InvoiceMetricBody invoice={invoice} workflowStatus={workflowStatus} />
    </InvoicePdfSlide>
  );
};

export default InvoiceMetricSlide;
